/**
 * platform.js — runtime platform detection for the RARE GROUP PWA.
 *
 * The same React build is served to:
 *   • Desktop / mobile web browsers visiting https://rgpro.info
 *   • The Capacitor iOS WebView wrapper (App Store binary)
 *   • The Capacitor Android WebView wrapper (Play Store binary)
 *
 * Apple App Review rejects the build when iOS users get the web OAuth Sign in
 * with Apple flow instead of the native ASAuthorizationAppleIDProvider flow,
 * so we MUST detect native iOS reliably before deciding which Apple sign-in
 * flow to run.
 *
 * Capacitor exposes `window.Capacitor` whenever the app is hosted inside a
 * native Capacitor WebView. We use the official `@capacitor/core` helpers
 * (Capacitor.getPlatform() + Capacitor.isNativePlatform()) — these are SSR /
 * non-Capacitor safe because the package only ships browser-side code.
 */
import { Capacitor } from "@capacitor/core";

export function isNativePlatform() {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
}

export function getPlatform() {
  try { return Capacitor.getPlatform(); } catch { return "web"; }
}

export function isNativeIOS() {
  return isNativePlatform() && getPlatform() === "ios";
}

export function isNativeAndroid() {
  return isNativePlatform() && getPlatform() === "android";
}
